import React from "react";
import { Button, Empty } from "antd";

import style from "./style.module.scss";
import ExamBlock from "../../components/ExamBlock";
import { ExamItem } from "API";

interface ExamListPageMobileProps {
    refreshData: () => void;
    examList: ExamItem[];
    currentTime: string;
    onTipClick: () => void;
}

const ExamListPageMobile: React.FC<ExamListPageMobileProps> = ({
    refreshData,
    examList,
    currentTime,
    onTipClick
}) => {
    return (
        <div className={style.main}>
            <div style={{ textAlign: "right" }}>
                <Button type="link" onClick={onTipClick}>
                    点击链接查看白果云考试的注意事项
                </Button>
            </div>

            {examList.map((item, index) => (
                <ExamBlock
                    key={index}
                    name={item.name}
                    examId={item.type !== "3" ? item.examId : item.examInfo}
                    now={currentTime}
                    platform="Mobile"
                    className={style.examBlock}
                    type={item.type}
                    title={item.courseName}
                    startDateTime={item.startTime}
                    endDateTime={item.endTime}
                    times={item.times}
                    examInfo={item}
                    refreshData={refreshData}
                />
            ))}

            {examList.length === 0 && <Empty description="暂无考试" />}
        </div>
    );
};

export default ExamListPageMobile;
